import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { RootState } from 'store';

export type VehicleTrackingGroupByFilter = 'camera' | 'zone';

interface VehicleTrackingFilterState {
  selectedGroupBy: VehicleTrackingGroupByFilter;
  selectedVehicleTypes: string[];
  selectedLabels: string[];
}

const initialState: VehicleTrackingFilterState = {
  selectedGroupBy: 'zone',
  selectedVehicleTypes: [],
  selectedLabels: [],
};

export const vehicleTrackingDashboardFiltersSlice = createSlice({
  name: 'vehicleTrackingFilters',
  initialState,
  reducers: {
    updateGroupBy: (
      state,
      action: PayloadAction<VehicleTrackingGroupByFilter>,
    ) => {
      state.selectedGroupBy = action.payload;
    },
    updateSelectedLabels: (state, action: PayloadAction<string[]>) => {
      state.selectedLabels = action.payload;
    },
    updateVehicleTypes: (state, action: PayloadAction<string[]>) => {
      state.selectedVehicleTypes = action.payload;
    },
  },
});

export const { updateGroupBy, updateSelectedLabels, updateVehicleTypes } =
  vehicleTrackingDashboardFiltersSlice.actions;

export default vehicleTrackingDashboardFiltersSlice.reducer;

export const useGetVehicleTrackingFilters = () =>
  useSelector((state: RootState) => state.vehicleTrackingFilter);

export const useUpdateVehicleTrackingFilters = () => {
  const dispatch = useDispatch();

  const handleUpdateGroupBy = (newGroupBy: VehicleTrackingGroupByFilter) => {
    dispatch(updateGroupBy(newGroupBy));
  };
  const handleUpdateSelectedLabels = (newLabels: string[]) => {
    dispatch(updateSelectedLabels(newLabels));
  };
  const handleUpdateVehicleTypes = (newVehicles: string[]) => {
    dispatch(updateVehicleTypes(newVehicles));
  };

  return {
    handleUpdateGroupBy,
    handleUpdateSelectedLabels,
    handleUpdateVehicleTypes,
  };
};
